<div class="insights-request-access container-lg mt-3">
  <div *ngIf="isLoading" class="text-center py-5">
    <i class="fa fa-spinner fa-spin fa-3x" aria-hidden="true"></i>
  </div>

  <ng-container *ngIf="!isLoading">
    <header class="insights-request-access__header">
      <h1 class="insights-request-access__title">
        You are requesting access to {{ insightsBrand }} for {{ companyName }}
      </h1>
      <div class="insights-request-access__agreement">
        <p class="insights-request-access__agreement-text mb-3">
          &ldquo;I am authorised to access {{ insightsBrand }} and understand Altius may verify my eligibility with {{ companyName }}&rdquo;
        </p>
        <div class="form-check">
          <input id="agreeCheck" type="checkbox" class="form-check-input" [(ngModel)]="agreed" />
          <label class="form-check-label" for="agreeCheck">I agree</label>
        </div>
      </div>
    </header>

    <div class="insights-request-access__cards row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-3">
      <div class="col" *ngFor="let dashboard of requestableDashboards">
        <div class="dashboard-card h-100">
          <div class="dashboard-card__thumbnail">
            <img
              *ngIf="dashboard.photo"
              [src]="insightsService.getDashboardPhotoUrl(dashboard.photo)"
              [alt]="dashboard.name"
              class="dashboard-card__img"
            />
            <div *ngIf="!dashboard.photo" class="dashboard-card__img-placeholder">
              <i class="fa fa-bar-chart fa-3x" aria-hidden="true"></i>
            </div>
          </div>

          <div class="dashboard-card__body">
            <p class="dashboard-card__title">{{ dashboard.name }}</p>
            <p class="dashboard-card__description">{{ dashboard.description }}</p>
          </div>

          <div class="dashboard-card__footer insights-request-access__footer">
            <span class="insights-request-access__request-label">Request</span>
            <input
              type="checkbox"
              class="form-check-input insights-request-access__request-check"
              [checked]="isSelected(dashboard)"
              (change)="toggleSelection(dashboard)"
            />
          </div>
        </div>
      </div>
    </div>

    <p *ngIf="requestableDashboards.length === 0" class="insights-request-access__empty">
      There are no dashboards available to request.
    </p>

    <p *ngIf="errorMessage" class="text-danger small mb-2">{{ errorMessage }}</p>

    <div class="insights-request-access__actions">
      <button
        type="button"
        class="btn btn-primary insights-request-access__submit"
        [disabled]="!canSubmit || submitted"
        (click)="onSubmit()">
        {{ submitting ? 'Submitting...' : 'REQUEST ACCESS' }}
      </button>
    </div>
  </ng-container>
</div>
